import { homologationConstants} from '../_constants';
import { homologationService } from '../_services';
import { alertActions } from './';
import { history } from '../_helpers';

export const homologationActions = {
  insertarTramiteHomologation,  
};
function insertarTramiteHomologation(tramite,documentList) {
    return dispatch => {
        dispatch(request());

        homologationService.insertTramiteH(tramite,documentList)
            .then(
                tramite => dispatch(success(tramite)),
                error => dispatch(failure(error.toString()))
            );
    };
    function request() { return { type: homologationConstants.INSERT_REQUEST } }
    function success(tramite) { return { type: homologationConstants.INSERT_SUCCESS, tramite } }
    function failure(error) { return { type: homologationConstants.INSERT_FAILURE, error } }
}